<div class="language-select-wrapper">
  <select
    class="form-select text-uppercase fw-bold p-0 border-0 text-primary cursor-pointer"
    [ngModel]="i18nService.currentLanguage"
    (ngModelChange)="switchLanguage($event)"
    [attr.aria-label]="'button.language-select' | translate"
  >
    <option *ngFor="let lang of languages" [ngValue]="lang">
      {{ getLangLabel(lang) }}
    </option>
  </select>
</div>
